import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

// The scheduler (questions-revealScheduled) ticks on */15, so the picker only
// ever offers slots a tick lands on — a reveal is then seconds late, never
// up to fourteen minutes.
export const QUARTER_HOUR_TIMES = Array.from({ length: 96 }, (_, index) => {
  const hours = String(Math.floor(index / 4)).padStart(2, '0');
  const minutes = String((index % 4) * 15).padStart(2, '0');
  return `${hours}:${minutes}`;
});

// Only reached in browsers without Intl.supportedValuesOf (Safari < 15.4).
const FALLBACK_TIMEZONES = [
  'UTC',
  'Europe/Dublin',
  'Europe/London',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Rome',
  'Europe/Athens',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Sao_Paulo',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Australia/Sydney'
];

export const listTimezones = () => {
  if (typeof Intl.supportedValuesOf === 'function') {
    try {
      return Intl.supportedValuesOf('timeZone');
    } catch (error) {
      // fall through to the static list
    }
  }
  return FALLBACK_TIMEZONES;
};

export const browserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Resolves a moderator's wall-clock choice ("2026-09-14", "12:00" in
 * Asia/Seoul) to the UTC instant Firestore stores. Returns null when the
 * inputs do not form a valid time (an unset date, an unknown zone).
 */
export const buildScheduledInstant = ({ date, time, timezone }) => {
  if (!date || !time || !timezone) return null;
  try {
    const parsed = dayjs.tz(`${date} ${time}`, timezone);
    return parsed.isValid() ? parsed.toDate() : null;
  } catch (error) {
    return null;
  }
};

// The inverse, for editing an existing schedule in the zone it was set in.
export const toZonedParts = (date, timezone) => {
  const zoned = dayjs(date).tz(timezone);
  return { date: zoned.format('YYYY-MM-DD'), time: zoned.format('HH:mm') };
};
